'use strict';

// TODO

frontendApp.directive('iioToggle', function () {
  return {
    restrict: 'E',
    template: '<div class="iio-toggle btn-group" data-toggle="buttons-radio">' +
      '<button type="button" class="btn active">Offline</button>' +
      '<button type="button" class="btn">Online</button>' +
      '</div>',
    link: function (scope, element, attrs) {
      // Off Label
      // On Label

      // Off callback
      // On callback
    }
  }
});
